module.exports = ".welcome-container {\n  min-width: 100vw;\n  min-height: 100vh;\n  background-color: #641322;\n}\n"